import React, {useEffect} from 'react';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
    competitionRegistrationStatusColor,
    competitionRegistrationStatusLabel,
    eventStatus, registrationStatus
} from "../../util/standards-util";
import Box from "@mui/material/Box";
import {useWithdrawFromEventMutation} from "../../slices/apiSlice";
import {useSelector} from "react-redux";
import {Chip} from "@mui/material";
import ConfirmationDialog from "../ConfirmationDialog";

const canWithdraw = (registration, event) => {
    return event.status > eventStatus.STATUS_COMPLETED &&
        registration.u > registrationStatus.STATUS_BANNED &&
        registration.u < registrationStatus.STATUS_RESUBMITTED &&
        registration.u !== registrationStatus.STATUS_REJECTED
}

const RegistrationStatusPilotWidget = ({ entry, event, onUpdate }) => {
    const session = useSelector( state => state.session)

    const [registration, setRegistration] = React.useState(entry.registration)
    const [isOwner, setIsOwner] = React.useState(false)
    const [isWithdrawable, setIsWithdrawable] = React.useState(canWithdraw(entry.registration, event))
    const [doConfirm, setDoConfirm] = React.useState(false)

    const [withdraw, withdrawResult] =useWithdrawFromEventMutation()

    const handleClicked = (e) => {
        e.stopPropagation()
        setDoConfirm(true)
    }

    const handleConfirmClosed = (confirmed) => {
        setDoConfirm(false)
        if (confirmed)  withdraw(event.id)
    }

    useEffect(() => {
        setIsWithdrawable(canWithdraw(registration,event))
    }, [registration,event]);

    useEffect(() => {
        setIsOwner(session.pilot?.id === entry.registration.p)
    }, [session.pilot]);

    useEffect(() => {
        if (withdrawResult.isSuccess){
            if (onUpdate && withdrawResult.data.status === "ok") onUpdate(withdrawResult.data.data)

            setRegistration(withdrawResult.data.data)
        }
    }, [withdrawResult]);

    return (
        <Box sx={{display:'flex',alignItems:'center'}}>
            <Typography variant={'body1'} mr={1}>Status:</Typography>
                <Chip
                    label={competitionRegistrationStatusLabel[registration.u] ?? ''}
                    color={competitionRegistrationStatusColor[registration.u] ?? 'warning'}
                />

            {isOwner && isWithdrawable &&
                <Button
                    variant={'contained'}
                    size={'small'}
                    onClick={handleClicked}
                    sx={{ml:2}}
                >
                    Withdraw
                </Button>
            }
            {doConfirm &&
                <ConfirmationDialog title={'Withdraw from event'} body={
                    <>
                        <Box>Are you sure you would like to withdraw from the {event.fullEditionTitle}</Box>
                    </>
                }
                                    onCancel={() => handleConfirmClosed(false)}
                                    onConfirm={() => {handleConfirmClosed(true)}}
                                    confirmText='Withdraw'
                />
            }
        </Box>
    )
}

export default RegistrationStatusPilotWidget;